import { usersTypes } from "./types";
import { orderArrayV2 } from "helpers/orderArray";
import { addLabelArray } from "helpers/addLabelArray";

const {
  SET_USERS,
  NEW_USER,
  SELECT_USER,
  UNSELECT_USER,
  UPDATE_USER,
  REMOVE_USER,
  SET_PRINTER,
  REMOVE_PRINTER,
  SET_CONFIG_PAGE_USERS_SECTION,
  SET_CONFIG_PAGE_SIZE_USERS_SECTION,
  SET_CONFIG_SORTED_USERS_SECTION,
  SET_CONFIG_FILTERED_USERS_SECTION,
  GET_USER_BY_STATIONS,
} = usersTypes;

const initialState = {
  users: [],
  user: {},
  usersStation: [],
  isEdit: false,
  rules: [],
  config: {
    page: 0,
    pageSize: 50,
    sorted: [],
    filtered: [],
  },
};

export const usersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USERS:
      const labelUsers = addLabelArray(payload.users, 'name',)
      return {
        ...state,
        users: labelUsers,
        rules: orderArrayV2(payload.rules, 'label'),
      }

    case NEW_USER:
      const newUsers = [{ ...payload }, ...state.users]
      return {
        ...state,
        users: newUsers
      }

    case SELECT_USER:
      return {
        ...state,
        isEdit: true,
        user: payload
      }

    case UNSELECT_USER:
      return {
        ...state,
        isEdit: false,
        user: {}
      }

    case UPDATE_USER:
      const idx = state.users.findIndex(user => user.id === payload.id);
      if (idx === -1) return state
      const updatedUsers = [...state.users];
      updatedUsers[idx] = payload;
      return {
        ...state,
        users: updatedUsers,
      };

    case REMOVE_USER:
      return {
        ...state,
        users: state.users.filter(user => user.id !== payload),
      }

    case SET_PRINTER:
      const users = [...state.users]
      const idxU = users.findIndex(user => user.id === payload.id)
      if (idxU === -1) return state
      users[idxU].config.printers = [payload.idPrinter]
      return {
        ...state,
        users
      }

    case REMOVE_PRINTER:
      return {
        ...state,

      }
    case GET_USER_BY_STATIONS:
      return {
        ...state,
        usersStation: payload
      }
    case SET_CONFIG_FILTERED_USERS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };
    case SET_CONFIG_PAGE_USERS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };
    case SET_CONFIG_PAGE_SIZE_USERS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };
    case SET_CONFIG_SORTED_USERS_SECTION:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    default: return state
  }
}